module.exports = __webpack_public_path__ + "static/media/Video-Banner-Desktop.6f113c69.jpg";